import axios from 'axios'
import jwt_decode from 'jwt-decode'
import { setErrorLog } from './DashboardService'
import { useSelector } from 'react-redux'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401]

let projectInfo
const updateProjectInfo = () => {
    projectInfo = store.getState().auth.user
}

const BaseService = axios.create({
    timeout: 600000,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(config => {
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    const persistData = deepParseJson(rawPersistData)

    const accessToken = persistData.auth.session.token

    // Callback fonksiyonu çağır
    updateProjectInfo()

    // Değişkeni kullan
    const newUrl = config.url.split("?");
    if (accessToken && projectInfo) {
        if (config.url !== 'https://labelev.neocortexs.com/servis' && newUrl[0] !== 'https://labelev.neocortexs.com/yenirapor') {
            config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
            //config.headers['project_id'] = projectInfo.project_id
            config.headers['project_id'] = 1
        }
    }
    return config
}, error => {
    return Promise.reject(error)
})

BaseService.interceptors.response.use(
    response => response,
    error => {
        const { response } = error

        // --- LOGLAMA BAŞLANGIÇ ---
        if (response && error.config) {
            const requestUrl = error.config.url || error.config.baseURL || '';

            // 1. Kural: 404 hatalarını loglama (gereksiz trafik)
            const isNot404 = response.status !== 404;

            // 2. Kural: Log servisine atılan istekleri tekrar loglama (Sonsuz döngü koruması)
            const isNotLogRequest = !requestUrl.includes('setlog');
            if (isNot404 && isNotLogRequest) {
                try {
                    let userId = 0;
                    try {
                        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
                        if (rawPersistData) {
                            const persistData = deepParseJson(rawPersistData);
                            const token = persistData?.auth?.session?.token;

                            if (token) {
                                const decoded = jwt_decode(token);
                                userId = decoded.user_id || decoded.id || decoded.sub || 0;
                            }
                        }
                    } catch (e) { /* Token okuma hatası önemsiz */ }
                    const logData = {
                        user_id: userId,
                        occurred_at: new Date().toISOString().slice(0, 19),
                        platform: "WEB",
                        requested_url: requestUrl,
                        request_method: (error.config.method || 'GET').toUpperCase(),
                        client_ip: window.location.hostname || '',
                        request_header: error.config.headers || {},
                        request_dict: error.config.data || error.config.params || {},
                        response_status_code: response.status || 0,
                        response_dict: response.data || {},
                        log_level: response.status >= 500 ? "ERROR" : "INFO",
                        message: error.message || 'Request failed',
                        stack_trace: error.stack || '',
                        device_info: navigator.userAgent || '',
                        browser_info: navigator.userAgent || '',
                        app_version: "1.0.0",
                        send_to_client: false
                    };
                    // Logu gönder (Asenkron)
                    setErrorLog(logData).catch(() => { });

                } catch (logError) {
                    console.error('Log hazırlama hatası:', logError);
                }
            }
        }
        // --- LOGLAMA BİTİŞ ---

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        return Promise.reject(error)
    }
)

export default BaseService